import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=8bec7604&"
import script from "./TinymceEditor.vue?vue&type=script&lang=js&"
export * from "./TinymceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports